import type { NavigateFunction, Location } from 'react-router-dom'

/** Open the sign-in modal over the current screen (keeps background location). */
export function openSignIn(
  navigate: NavigateFunction,
  location: Location,
  next?: string,
) {
  const params = next ? `?next=${encodeURIComponent(next)}` : ''
  navigate(`/signin${params}`, { state: { background: location } })
}
